import SelectDinamico from "../../SelectDinamico";
import ConsultaFinalidade from "../../../../lib/json/consultas/Finalidade.json"
import { RetornaUsuarioLogado } from "../../../contents/VariaveisGlobais";

function SelectFinalidade({campoFinalidade, changeFinalidade, queryFinalidade, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, bindItem, field, showNoFilter = false}){
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')
    const usuarioLogado = RetornaUsuarioLogado(true, empresaFilial);
    
    let filtraFinalidades = ''
    let consultaDefault = ConsultaFinalidade.consulta + " WHERE D_E_L_E_T_ <> '*' AND DHK_FILIAL = FILIAL(DHK) AND DHK_ATIVO != '2' "

    const consulta = queryFinalidade || ( loadDefault ? consultaDefault + filtraFinalidades : '' )
    const finalidadeValue = bindItem ? bindItem[field] : campoFinalidade;

    return (
        <SelectDinamico
            label="Finalidade"
            cText="DHK_CODIGO + ' - ' + item.DHK_DESCR"
            cValue="DHK_CODIGO"
            campoValue={finalidadeValue}
            consulta={consulta}
            tabela={ConsultaFinalidade.tabelas}
            isMultiplo={false}
            showNoFilter={showNoFilter}
            EmpresaLogada={empresaFilial}
            onchange={(e) => changeFinalidade(e)}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    )
}

export default SelectFinalidade;